import React from 'react';
import BuildSettings from '../buildSettings';

export default class BuildIdentificationBadge extends React.PureComponent {
    render() {
        return <div className="layout-main-navigation-build-idenficiation">{BuildSettings.buildId}</div>
    }
}